import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx'; // Import xlsx
import '../styles/ModeratorFeedback.css'; 
import videoPlay from '../images/videoPlay.png';
import excel_icon from '../images/excel_icon.png';
import dropdown_open from '../images/dropdown_open.png';
import dropdown_close from '../images/dropdown_close.png';
import { allFeedbacks } from '../Services/AllServices'; // Adjust the import path

const ModeratorFeedback = () => {
  const [usersFeedback, setUsersFeedback] = useState([]);
  const [sortBy, setSortBy] = useState('Sort By');
  const [isSortByDropdownOpen, setIsSortByDropdownOpen] = useState(false);
  const navigate = useNavigate()

  const toggleSortByDropdown = () => setIsSortByDropdownOpen(!isSortByDropdownOpen);

  const handleSortBySelect = (order) => {
    setSortBy(order);
    setIsSortByDropdownOpen(false);

    let sortedUsersFeedback;
    if (order === 'Oldest') {
      sortedUsersFeedback = [...usersFeedback].sort((a, b) => b._id.localeCompare(a._id));
    } else if (order === 'Latest') {
      sortedUsersFeedback = [...usersFeedback].sort((a, b) => a._id.localeCompare(b._id));
    }
    setUsersFeedback(sortedUsersFeedback);
  };

  // Fetch feedbacks
  useEffect(() => {
    const fetchFeedbacks = async () => {
      const callback = (response) => {
        console.log('Feedback Response:', response);
        if (response.status === "success") {
          setUsersFeedback(response.data); // Set the feedback data in state
        } else {
          console.error('Error fetching feedbacks:', response.message);
        }
      };

      await allFeedbacks(callback); // Call the allFeedbacks API
    };

    fetchFeedbacks();
  }, []);

  // Function to export data as Excel
  const exportAsExcel = () => {
    // Prepare the data for Excel
    const excelData = usersFeedback.map((feedback) => {
      if (feedback.profile === 'Student') {
        return {
          Role: feedback.profile,
          'Video Title': feedback.title,
          // 'Video URL': feedback.videofile.url,
          'Feedback Description': feedback.description,
        };
      } else if (feedback.profile === 'Teacher') {
        return {
          Role: feedback.profile,
          'Feedback Description': feedback.description,
        };
      }
      return {}; // Default case to prevent undefined values
    });

    // Create a new worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Feedback Data');

    // Generate the Excel file and download it
    XLSX.writeFile(workbook, 'FeedbackData.xlsx');
  };
  const handleVideoClick = (feedback) => {
    const videoData = usersFeedback;
    const video = feedback;
    console.log(video);
    navigate('/videoplayer', { state: { video: feedback, videoData } });
};

  return (
    <div className="feedback">
      <div className='feedbacks-container'>
      <h1>Feedback</h1>

      {/* Dropdowns for filtering and sorting */}
      <div className="moderator-filters">
         {/* Custom Sort By Dropdown */}
         <div className={`moderator-custom-select ${isSortByDropdownOpen ? "open" : ""}`}>
          <div className="moderator-custom-select-sortby" onClick={toggleSortByDropdown}>
            {sortBy}
            <span className="moderator-custom-select-arrow">
              {isSortByDropdownOpen ? (
                <img
                  src={dropdown_close}
                  alt="dropdown open"
                  className="moderator-dropdown-icon"
                />
              ) : (
                <img
                  src={dropdown_open}
                  alt="dropdown close"
                  className="moderator-dropdown-icon"
                />
              )}
            </span>
          </div>
          {isSortByDropdownOpen && (
            <div className="moderator-custom-sortby-options">
              {['Latest', 'Oldest'].map((option) => (
                <div
                  key={option}
                  className="moderator-custom-select-option"
                  onClick={() => handleSortBySelect(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Export as Excel button */}
        <button className='excel' onClick={exportAsExcel}>
          <div className='excel_icon'><img src={excel_icon} alt='excel icon'/></div>
          <div className='excel_text'>Export as excel </div>
        </button>
      </div>

      <div className="feedback-list">
        {usersFeedback.map((feedback) => (
          <div key={feedback._id}> {/* Use _id for key */}
            {feedback.profile === 'Student' ? (
              <div href={feedback.videofile.url} className="moderator-video-item" target="_blank" rel="noreferrer">
                <div className="student-feedback-card">
                  {/* UI for Student */}
                  <div className='moderator-video_thumbnail' onClick={() => handleVideoClick(feedback)}>
                      <img src={feedback.thumbnail.url} alt="Thumbnail"/> {/* Use dynamic thumbnail URL */}
                  </div>
                  <div className="moderator-video_details">
                    <div className='moderator-video_title_play'>
                      <div className='moderator-video_title'>{feedback.title}</div>
                      <div className='moderator-video_play' onClick={() => handleVideoClick(feedback)}> <img src={videoPlay} alt="play"/> </div>
                    </div>
                    <div className="feedback-user-role"> {feedback.profile} </div>
                    <div className='user_feedback'>{feedback.description}</div> {/* Use the description field */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="teacher-feedback-card">
                  <div className='feedback_heading'>Feedback</div>
                  <div className="feedback-user-role"> {feedback.profile} </div>
                  <div className='user_feedback'>{feedback.description}</div> {/* Use the description field */}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default ModeratorFeedback;
